export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
    return count === 1 ? singular : plural;
}

// pluralizeWithCount returns a string with the count and the pluralized word.
// If hasMore is true, a "+" is appended to the count.
// Example: pluralizeWithCount(1, false, "project") returns "1 project"
export const pluralizeWithCount = (count: number, hasMore: boolean, singular: string, plural = `${singular}s`) => {
    return `${count}${hasMore ? "+" : ""} ${pluralize(count, singular, plural)}`;
};

/**
 * Sanitizes a prompt string by removing non-ASCII characters.
 * Allows printable ASCII (0x20-0x7E), tab (0x09), newline (0x0A), and carriage return (0x0D).
 * This prevents Unicode injection attacks using invisible characters like zero-width spaces or RTL overrides.
 */
export function sanitizePrompt(input: string): string {
    let result = "";
    for (const char of input) {
        const code = char.charCodeAt(0);
        // Allow: tab (0x09), newline (0x0A), carriage return (0x0D), printable ASCII (0x20-0x7E)
        if (code === 0x09 || code === 0x0a || code === 0x0d || (code >= 0x20 && code <= 0x7e)) {
            result += char;
        }
    }
    return result;
}
